// eslint-disable-next-line no-unused-vars
import { Breadcrumb, Button, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import { Link, useParams } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import UploadDocumentModal from "../../../components/Modals/UploadDocumentModal";
// eslint-disable-next-line no-unused-vars
import PatientDocumentsTable from "../../../components/Tables/PatientDocumentsTable";
import { translate } from "../../../locale";
import UserServices from "../../../services/UserServices";
// eslint-disable-next-line no-unused-vars
const { Title } = Typography;

const PatientDocuments = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [reloadTable, setReloadTable] = useState(0);
  const [patient, setPatient] = useState(null);
  const { username } = useParams();

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const res = await UserServices.getProfile(username);
        if (res.status >= 200 && res.status < 300) {
          setPatient(res.data.my_contact_info);
        }
      } catch (err) {
        console.log(err);
      }
    };
    fetchPatient();
  }, [username]);

  const handleNewPdf = () => {
    setModalVisible(true);
  };

  const handleModalComplete = () => {
    setModalVisible(false);
    setReloadTable((v) => v + 1);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {translate("Carga de documentos")}
            </Breadcrumb.Item>
            {patient && (
              <Breadcrumb.Item>
                {patient.first_name} {patient.last_name} - {username}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Carga de documentos")}
          </Title>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              data-testid="patient-documents-btn-new-pdf"
              onClick={handleNewPdf}
            >
              {translate("Nuevo PDF")}
            </Button>
          </div>
        </Col>

        <Col span="24" className="mt-6">
          <PatientDocumentsTable
            reload={reloadTable}
            onDelete={() => {}}
          />
        </Col>
      </Row>

      <UploadDocumentModal
        username={username}
        visible={modalVisible}
        mode="create"
        document={null}
        onComplete={handleModalComplete}
        onCancel={handleModalCancel}
      />
    </div>
  );
};

export default PatientDocuments;
